import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout/layout.component';
import {HomeComponent} from './routes/home/home.component';
import {ConcessionariaResolver} from './_resolvers/concessionaria.resolver';
import {DocumentosResolver} from './_resolvers/documentos.resolver';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    resolve: {
      documentos: DocumentosResolver
    },
    children: [
      {
        path: '',
        component: HomeComponent,
        resolve: {
          concessionarias: ConcessionariaResolver
        }
      },
      {
        path: 'promocoes-associados',
        loadChildren: () => import('./routes/associated-promotions/associated-promotions.module')
          .then(m => m.AssociatedPromotionsModule),
      },
      {
        path: 'entregabenz',
        loadChildren: () => import('./routes/entregabenz/entregabenz.module').then(m => m.EntregabenzModule),
      },
      {
        path: 'fale-conosco',
        loadChildren: () => import('./routes/fale-conosco/fale-conosco.module').then(m => m.FaleConoscoModule),
      },
      {
        path: 'cotacao-pecas',
        loadChildren: () => import('./routes/cotacao-pecas/cotacao-pecas.module').then(m => m.CotacaoPecasModule),
      },
      {
        path: 'agendamento',
        loadChildren: () => import('./routes/agendamento/agendamento.module').then(m => m.AgendamentoModule),
      },
      {
        path: 'paginas/:rota',
        loadChildren: () => import('./routes/template/template.module').then(m => m.TemplateModule),
      },
      {
        path: 'concessionarias',
        loadChildren: () => import('./routes/concessionarias/concessionarias.module').then(m => m.ConcessionariasModule),
      },
      {
        path: 'veiculos',
        loadChildren: () => import('./routes/veiculos/veiculos.module').then(m => m.VeiculosModule),
      },
      {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
      }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    relativeLinkResolution: 'legacy',
    initialNavigation: 'enabled',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
